/**
 * Shared job role types for API contracts between frontend and backend
 */
import { z } from "zod";
import { uuidSchema, ttocJobCodeSchema } from "./validation-common.js";
import { PayConfigurationResponseSchema } from './payConfiguration.js';
// SkillReference schema
export const SkillReferenceSchema = z.object({
    id: z.uuid(),
    name: z.string(),
});
// RangeSettings schema
export const RangeSettingsSchema = z.object({
    min: z.number(),
    idealMin: z.number(),
    idealMax: z.number(),
    max: z.number(),
});
// ScheduleSettings schema
export const ScheduleSettingsSchema = z.object({
    id: z.uuid(),
    shift: RangeSettingsSchema,
    weeklyHours: RangeSettingsSchema,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
// JobRole response schema
export const JobRoleResponseSchema = z.object({
    id: z.uuid(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    name: z.string(),
    jobCode: z.string().nullable(),
    ttocJobCode: z.string().nullable(),
    tipEligible: z.boolean().nullable(),
    notes: z.string(),
    jobLevelId: z.uuid(),
    jobRoleFamilyId: z.uuid(),
    companyId: z.uuid(),
    isArchived: z.boolean(),
    skills: z.array(SkillReferenceSchema),
    inheritedSkills: z.array(SkillReferenceSchema),
    payConfigurations: z.array(PayConfigurationResponseSchema),
});
// Input schemas
export const CreateJobRoleInputSchema = z.object({
    name: z.string().min(1).max(255),
    jobCode: z.string().optional(),
    ttocJobCode: ttocJobCodeSchema.optional(),
    tipEligible: z.boolean().optional(),
    jobLevelId: uuidSchema,
    jobRoleFamilyId: uuidSchema,
    companyId: uuidSchema,
    notes: z.string(),
});
export const UpdateJobRoleInputSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    jobCode: z.string().nullable().optional(),
    ttocJobCode: ttocJobCodeSchema.nullable().optional(),
    tipEligible: z.boolean().optional(),
    jobLevelId: uuidSchema.optional(),
    notes: z.string().optional(),
    isArchived: z.boolean().optional(),
});
export const UpdateJobRoleSkillsInputSchema = z.object({
    skillIds: z.array(z.uuid()),
});
export const AddJobRoleSkillInputSchema = z.object({
    skillId: uuidSchema,
});
// Archive/unarchive input schema - empty because companyId comes from JWT context
// The id comes from the path parameter in the contract
export const ArchiveJobRoleInputSchema = z.object({});
